import left_arrow_enable from "../assets/images/arrow/left/left_arrow_enable.svg";
import left_arrow_disable from "../assets/images/arrow/left/left_arrow_disable.svg";
import right_arrow_disable from "../assets/images/arrow/right/right_arrow_disable.svg";
import right_arrow_enable from "../assets/images/arrow/right/right_arrow_enable.svg";
import request_received_search from "../assets/images/request-received-search.svg";
import clear_search from "../assets/images/clear-search.svg";
import favourite_icon_enabled from "../assets/images/favourite-ico-active.svg";
import favourite_icon_disabled from "../assets/images/favourite-inactive.svg";
import more_selected from "../assets/images/more-selected.svg";
import more from "../assets/images/more-unselected.svg";
import no_request from "../assets/images/no-request.png";
import one_to_one_icon_blue_bg from "../assets/images/one_to_one_icon_blue_bg.svg";
import group_icon_blue_bg from "../assets/images/group_icon_blue_bg.svg";
import awaiting_stopwatch from "../assets/images/awaiting_stopwatch.svg";
import tip_with_blue_bg from "../assets/images/tip_with_blue_bg.svg";
import tip_with_white_bg from "../assets/images/tip_with_white_bg.svg";

import take_tip_with_blue_bg from "../assets/images/take_tip_with_blue_bg.svg";

import tip_goal_with_blue_bg from "../assets/images/tip_goal_with_blue_bg.svg";
import tip_goal_with_white_bg from "../assets/images/tip_goal_with_white_bg.svg";

import loading_blue from "../assets/gif/loading_blue.gif";
import loading_white from "../assets/gif/loading_white.gif";

import tip_active from "../assets/images/web/web/tip-active.svg";
import tip_in_active from "../assets/images/web/web/tip-inactive.svg";

import tip_goal_active from "../assets/images/web/web/tip-goal-active.svg";
import tip_goal_inactive from "../assets/images/tip_goal_inactive.svg";

import wallet from "../assets/images/request-session-wallet-balance-icon.svg";

import add_credit_wallet_outline from "../assets/images/wallet.svg";
import coffee from "../assets/images/tipicon/coffeecup.svg";
import meal from "../assets/images/tipicon/meal.svg";
import gift from "../assets/images/tipicon/gift.svg";
import impress from "../assets/images/tipicon/impress.svg";

import showmelove from "../assets/images/tipicon/showmelove.svg";
import thankme from "../assets/images/tipicon/thankme.svg";
import wowme from "../assets/images/tipicon/wowme.svg";

import thank_you_hand_white_bg from "../assets/images/thank_you_hand_white_bg.svg"
import private_views from "../assets/images/private_views.svg"
import group_views from "../assets/images/group_views.svg"

import tip_empty_state from "../assets/images/tip_empty_state.svg"
import user_placeholder from "../assets/images/user-placeholder.svg"
import loading_blue_new from "../assets/gif/blue.gif";

import cross from "../assets/images/broadcast/cross.svg";
//send message
import send_disable from "../assets/images/broadcast/send-disable.svg";
import send_enable from "../assets/images/broadcast/send-enable.svg";
//chat
import chat_inactive from "../assets/images/broadcast/video/chat-inactive.svg";
import chat_active from "../assets/images/broadcast/video/chat-active.svg";
//one to one
import one_to_one_active from "../assets/images/broadcast/video/1on1-active.svg";
import one_to_one_inactive from "../assets/images/broadcast/video/1on1-inactive.svg";
//group
import group_active from "../assets/images/broadcast/video/group-active.svg";
import group_inactive from "../assets/images/broadcast/video/group-inactive.svg";
//tip
import _tip_active from "../assets/images/broadcast/video/tip-active.svg";
import tip_inactive from "../assets/images/broadcast/video/tip-inactive.svg";
import like_active from "../assets/images/broadcast/video/like-active.svg";
import like_inactive from "../assets/images/broadcast/video/like.svg";
//tipgoal
import tipgoal_active from "../assets/images/broadcast/video/tipgoal-active.svg";
import tipgoal_inactive from "../assets/images/broadcast/video/tipgoal-inactive.svg";

//more
import more_active from "../assets/images/broadcast/video/more-active.svg";
import more_inactive from "../assets/images/broadcast/video/more-inactive.svg";

import has_notification from "../assets/images/broadcast/video/has-notification.svg";

import tip_not_selected from "../assets/images/tipicon/donate-notselected.svg";
import is_favourite_circle from "../assets/images/is-favourite-circle.svg"
import pristine_audio from "../assets/pristine.mp3";
import leaving_the_broadcast from "../assets/images/broadcast/video/leaving-the-broadcast.svg";

// clipstore
import EmptyState from "../assets/images/clipstore/EmptyState.svg"
import publishVideo from "../assets/images/clipstore/more/publish-video.svg"
import duplicateVideo from "../assets/images/clipstore/more/duplicate.svg"
import deleteVideo from "../assets/images/clipstore/more/delete.svg"
import editVideo from "../assets/images/clipstore/more/edit.svg"
import shareVideo from "../assets/images/clipstore/more/share.svg"
import reportVideo from "../assets/images/clipstore/more/report.svg"
import premium from "../assets/images/clipstore/premium.svg"
import exclusive from "../assets/images/clipstore/exclusive.svg"
import added_to_gallery from "../assets/images/clipstore/added-to-gallery.svg"
import plus from "../assets/images/clipstore/plus.svg"

//colabsible
import multipleCollapsableDelete from "../assets/images/clipstore/multiple-collapsable/delete.svg"
import multipleCollapsablePublish from "../assets/images/clipstore/multiple-collapsable/publish.svg"

import placeholder from "../assets/images/clipstore/placeholder.svg"
import delete_icon from "../assets/images/clipstore/delete-icon.svg"
import upload from "../assets/images/clipstore/upload.svg"
import uploading_image from "../assets/images/clipstore/upload/image.svg"
import uploading_video from "../assets/images/clipstore/upload/video.svg"
import success_icon from "../assets/images/clipstore/upload/success-icon.svg"
import information from "../assets/images/information.svg";
import gallery_placeholder from "../assets/images/clipstore/gallery-placeholder.svg";
import back from "../assets/images/clipstore/back.svg";
import gallery_videos from "../assets/images/clipstore/gallery-videos.svg";
import picture from "../assets/images/clipstore/picture.svg";
import chip_cross from "../assets/images/clipstore/home/content-type/cross.svg";

import placeholder_test from "../assets/images/clipstore/home/e95b8c2fb23b14b5e73f52abadf3a8e3.svg";

import home_more from "../assets/images/clipstore/home/more.svg";
import home_more_selected from "../assets/images/clipstore/home/more-selected.svg";

import broadcaster_verified from "../assets/images/clipstore/home/verified.svg";
import broadcaster_unverified from "../assets/images/clipstore/home/unverified.svg";

import status_away from "../assets/images/clipstore/home/status/away.svg";
import status_busy from "../assets/images/clipstore/home/status/busy.svg";
import status_online from "../assets/images/clipstore/home/status/online.svg";

import more_fav from "../assets/images/clipstore/home/more/fav.svg";
import more_follow from "../assets/images/clipstore/home/more/follow.svg";
import more_report from "../assets/images/clipstore/home/more/report.svg";
import more_share from "../assets/images/clipstore/home/more/share.svg";
import more_unfollow from "../assets/images/clipstore/home/more/unfollow.svg";
import more_view_profile from "../assets/images/clipstore/home/more/view_profile.svg";

import content_zero from "../assets/images/empty_state/content-zero.svg";
import no_result_for_search from "../assets/images/empty_state/no-result-for-search.svg";
import video_placeholder from "../assets/images/clipstore/video-placeholder.svg"
import video_play from "../assets/images/clipstore/play.svg"
import video_play_hover from "../assets/images/clipstore/play-hover.svg"
import purchased from "../assets/images/clipstore/purchased.svg"


import arrow_up from "../assets/images/clipstore/home/content-type/arrow-up.svg"
import arrow_down from "../assets/images/clipstore/home/content-type/arrow-down.svg"
import channelImageBg from "../assets/images/channelImageBg.jpg"

import subscribe_inactive from "../assets/images/broadcaster/profile/subscribe/inactive.svg"
import subscribe_active from "../assets/images/broadcaster/profile/subscribe/active.svg"
import follow_inactive from "../assets/images/broadcaster/profile/follow/inactive.svg"
import follow_active from "../assets/images/broadcaster/profile/follow/active.svg"
import tip from "../assets/images/broadcaster/profile/tip.svg"
import tick from "../assets/images/broadcaster/profile/tick.svg"
import dropdown from "../assets/images/broadcaster/profile/dropdown.svg"
import messaging_wallet from "../assets/images/messaging/wallet.svg"

//messaging
import searchInput from "../assets/images/messaging/search-input.svg"
import caret from "../assets/images/messaging/caret.svg"
import messaging_no_selection from "../assets/images/messaging/get-in-touch-with-the-users.svg"
import no_message from "../assets/images/empty_state/no-messages.svg";
import message_bubble_left from "../assets/images/messaging/message-bubble-left.svg";
import message_bubble_right from "../assets/images/messaging/message-bubble-right.svg";

//dropdown
import messaging_dropdown_block from "../assets/images/messaging/dropdown/block.svg";
import messaging_dropdown_delete from "../assets/images/messaging/dropdown/delete.svg";
import messaging_dropdown_archive from "../assets/images/messaging/dropdown/archive.svg";
import messaging_dropdown_mute from "../assets/images/messaging/dropdown/mute.svg";
import messaging_dropdown_report from "../assets/images/messaging/dropdown/report.svg";
import messaging_dropdown_select_messages from "../assets/images/messaging/dropdown/select-messages.svg";
import messaging_dropdown_unmute from "../assets/images/messaging/dropdown/unmute.svg";
import messaging_dropdown_view_profile from "../assets/images/messaging/dropdown/view-profile.svg";

import messaging_dropdown_icon_more_active from "../assets/images/messaging/dropdown/icon/more-active.svg";
import messaging_dropdown_icon_more_inactive from "../assets/images/messaging/dropdown/icon/more-inactive.svg";

import messaging_attachment_active from "../assets/images/messaging/send-message-bottom/attachment-active.svg";
import messaging_attachment_inactive from "../assets/images/messaging/send-message-bottom/attachment-inactive.svg";
import messaging_smile_active from "../assets/images/messaging/send-message-bottom/smile-active.svg";
import messaging_smile_inactive from "../assets/images/messaging/send-message-bottom/smile-inactive.svg";
import messaging_send from "../assets/images/messaging/send-message-bottom/send.svg";

import messaging_attachment_camera from "../assets/images/messaging/attachment/camera.svg";
import messaging_attachment_my_library from "../assets/images/messaging/attachment/my-library.svg";
import messaging_attachment_upload_from_pc from "../assets/images/messaging/attachment/upload-from-pc.svg";

//preview
import messaging_preview_big_grey_cross from "../assets/images/messaging/preview/big-grey-cross.svg";
import messaging_preview_big_white_cross from "../assets/images/messaging/preview/big-white-cross.svg";
import messaging_preview_big_white_plus from "../assets/images/messaging/preview/big-white-plus.svg";
import messaging_preview_big_white_send from "../assets/images/messaging/preview/big-white-send.svg";

import messaging_chats_active from "../assets/images/clipstore/chats-active.svg";
import messaging_chats_inactive from "../assets/images/clipstore/chats-inactive.svg";

//preview
import comments_down_arrow from "../assets/images/comments/down-arrow.svg";
import comments_up_arrow from "../assets/images/comments/up-arrow.svg";
import like_with_coin from "../assets/images/comments/like-with-coin.svg";
import like_with_coin_black from "../assets/images/comments/like-black.svg";
import home_like from "../assets/images/comments/like.svg";
import share_black from "../assets/images/comments/share.svg";

export default {

    broadcaster: {
        profile: {
            subscribe_inactive,
            subscribe_active,
            follow_inactive,
            follow_active,
            tip,
            tick,
            dropdown
        }
    },
    channelImageBg,
    empty:{
        content_zero,
        no_result_for_search
    },
    information,
    wallet,
    add_credit_wallet_outline,
    tip_not_selected,
    left_arrow_enable,
    left_arrow_disable,
    right_arrow_disable,
    right_arrow_enable,
    request_received_search,
    clear_search,
    favourite_icon_enabled,
    favourite_icon_disabled,
    more_selected,
    more,
    no_request,
    one_to_one_icon_blue_bg,
    group_icon_blue_bg,
    awaiting_stopwatch,
    tip_with_blue_bg,
    tip_with_white_bg,
    take_tip_with_blue_bg,
    tip_goal_with_blue_bg,
    tip_goal_with_white_bg,

    loading_blue,
    loading_white,

    tip_active,
    tip_in_active,
    tip_goal_active,
    tip_goal_inactive,


    tip: {
        coffee,
        meal,
        gift,
        impress,
        showmelove,
        thankme,
        wowme
    },
    thank_you_hand_white_bg,
    private_views,
    group_views,
    tip_empty_state,
    user_placeholder,
    loading_blue_new,

    broadcast: {
        cross,
        send_enable,
        send_disable,
        top_section: {
            chat_active,
            chat_inactive,
            one_to_one_active,
            one_to_one_inactive,
            group_active,
            group_inactive,
            tip_active: _tip_active,
            tip_inactive,
            tipgoal_active,
            tipgoal_inactive,
            more_active,
            more_inactive,
            has_notification,
            like_inactive,
            like_active
        }
    },

    clipstore: {
        home: {
            home_more,
            home_more_selected,
            broadcaster_verified,
            broadcaster_unverified,
            status: {
                online: status_online,
                away: status_away,
                busy: status_busy
            },
            more: {
                more_fav,
                more_follow,
                more_unfollow,
                more_report,
                more_share,
                more_view_profile,
            },
            video_placeholder,
            video_play,
            video_play_hover,
            purchased,
            arrow_up,
            arrow_down
        },
        placeholder_test,
        chip_cross,
        gallery_videos,
        picture,
        back,
        gallery_placeholder,
        premium,
        exclusive,
        added_to_gallery,
        EmptyState,
        more: {
            publishVideo,
            duplicateVideo,
            deleteVideo,
            editVideo,
            shareVideo,
            reportVideo
        },
        collapse: {
            multipleCollapsableDelete,
            multipleCollapsablePublish
        },
        placeholder,
        delete_icon,
        upload,
        uploading: {
            image: uploading_image,
            video: uploading_video
        },
        success_icon,
        plus
    },
    is_favourite_circle,
    pristine_audio,
    leaving_the_broadcast,

    messaging:{
        chat_icon_active:messaging_chats_active,
        chat_icon_inactive:messaging_chats_inactive,
        wallet:messaging_wallet,
        searchInput,
        caret,
        no_message,
        messaging_no_selection,
        message_bubble_left,
        message_bubble_right,
        dropdown:{
            view_profile:messaging_dropdown_view_profile,
            select_messages:messaging_dropdown_select_messages,
            delete_chat:messaging_dropdown_delete,
            archive:messaging_dropdown_archive,
            mute:messaging_dropdown_mute,
            unmute:messaging_dropdown_unmute,
            block:messaging_dropdown_block,
            report:messaging_dropdown_report,
            icon:{
                active:messaging_dropdown_icon_more_active,
                inactive:messaging_dropdown_icon_more_inactive
            }
        },
        bottom:{
            attachment_active:messaging_attachment_active,
            attachment_inactive:messaging_attachment_inactive,
            smile_active:messaging_smile_active,
            smile_inactive:messaging_smile_inactive,
            send:messaging_send,
        },
        attachment:{
            published: messaging_attachment_camera,
            my_library: messaging_attachment_my_library,
            pc: messaging_attachment_upload_from_pc
        },
        preview: {
            grey_cross: messaging_preview_big_grey_cross,
            white_cross: messaging_preview_big_white_cross,
            white_plus: messaging_preview_big_white_plus,
            white_send: messaging_preview_big_white_send
        }
    },

    comments: {
        down_arrow: comments_down_arrow,
        up_arrow: comments_up_arrow,
        like_with_coin:like_with_coin,
        like:home_like,
        like_with_coin_black:like_with_coin_black,
        share_black:share_black
    }
}